import * as yup from 'yup'

export const foundationAccrualValidationSchema = yup.object().shape({
    program_id: yup.string().required('Выберите программу'),
    bonus_id: yup.string().required('Выберите бонус'),
    amount: yup.number().typeError('Укажите число').required('Укажите количество бонусов'),
    comment: yup.string(),
})
